import { render, staticRenderFns } from "./WebsiteVhostPanel.vue?vue&type=template&id=11bcd5ae&"
import script from "./WebsiteVhostPanel.vue?vue&type=script&lang=ts&"
export * from "./WebsiteVhostPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports